exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1l511JUXS2Dfqo{background-color:#faf3c0;border-radius:4px;display:flex;color:#172b4d;margin-bottom:16px;padding:8px}._1l511JUXS2Dfqo ._4iAv8_xF4WMsRf{color:#172b4d}._1l511JUXS2Dfqo ._4iAv8_xF4WMsRf:hover{color:#091e42}._1l511JUXS2Dfqo .af_M9Ws7NruARK{font-weight:400;box-shadow:none;margin:0;padding:0;margin-left:auto}._1l511JUXS2Dfqo .af_M9Ws7NruARK,._1l511JUXS2Dfqo .af_M9Ws7NruARK:active,._1l511JUXS2Dfqo .af_M9Ws7NruARK:focus,._1l511JUXS2Dfqo .af_M9Ws7NruARK:hover{background:none}", ""]);

// exports
exports.locals = {
	"feedbackContainer": "_1l511JUXS2Dfqo",
	"feedbackLink": "_4iAv8_xF4WMsRf",
	"dismissButtonIcon": "af_M9Ws7NruARK"
};